import { render, staticRenderFns } from "./TextImageVideo.vue?vue&type=template&id=6f078330&scoped=true"
import script from "./TextImageVideo.vue?vue&type=script&lang=ts"
export * from "./TextImageVideo.vue?vue&type=script&lang=ts"
import style0 from "./TextImageVideo.vue?vue&type=style&index=0&id=6f078330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f078330",
  null
  
)

export default component.exports